import styled from 'styled-components';

export const SettingsMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        position: relative;
        background-image: linear-gradient(to bottom, #0b1b29 -60%, #554176 100%);
        background-repeat: no-repeat;
        background-size: auto 220px;
        @media(max-width:768px){
            flex-direction: column;
        }
    `,
);

export const SettingsMainWrapGcc = styled.div(
  props => `
        width:100%;
        display: flex;
        position: relative;
        background-image: linear-gradient(to bottom, #0b1b29 -60%, #554176 100%);
        background-repeat: no-repeat;
        background-size: auto 220px;
        @media(max-width:768px){
            flex-direction: column;
        }
    `,
);

export const SettingsTopBack = styled.div(
  props => `
        width:100%;
        display: flex;
        height: 20rem;
        background-color: ${props.theme.colors.blue.lightef};
        background-image:  linear-gradient(to bottom, #0b1b29 -60%, #554176 100%);
        //position: absolute;
        //top: 0;
        //left:0;
    `,
);

export const SettingsInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        max-width: 120rem;
        margin:30px auto;
        z-index:1;

        @media (max-width: 768px){
            flex-direction: column;
            max-width:100%;
        }
    `,
);

export const PopOverlay = styled.div(
  props => `
    width: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: ${props.theme.misc.zIndex.xlarge};
    background-color: ${props.theme.colors.black.light5};
    display: flex;
    aling-items: center;
    justify-content: center;
`,
);
